/**
 * PostHog Page Tracker
 *
 * Drop into the Router tree to auto-capture page views on SPA navigation.
 * Also captures UTM parameters from the initial landing URL.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/posthog';

export function PostHogPageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
